import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';
import Macy from "macy";
Swiper.use([Autoplay, Navigation, Pagination]);

export default class Show {
    constructor() {
        this.initTaxatie();
        this.initInspiratie();
    }

    initTaxatie() {
        new Swiper('#taxatie-table .swiper-container', {
            slidesPerView: 1,
            autoplay: {
                delay: 2500,
            },
            breakpoints: {
                576: {
                    slidesPerView: 3,
                }
            },
        });
    }

    initInspiratie(){
        if(!document.querySelector('#inspiratieContainer')) return;
        const macy = Macy({
            container: '#inspiratieContainer',
            trueOrder: false,
            waitForImages: false,
            margin: 27,
            columns: 3,
            breakAt: {
                768:{
                    columns: 1,
                    margin: {
                        x: 15,
                        y: 15,
                    },
                }
            }
        });
    }
}
